import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panel-config-usuario',
  templateUrl: './panel-config-usuario.component.html',
  styleUrls: ['./panel-config-usuario.component.scss']
})
export class PanelConfigUsuarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
